import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
/** Display rules for the stored phones ("+34|612345678" or legacy "+34612345678") */
export class PhoneService {
	/**
	 * Flag image of a stored phone's prefix ("+34|612345678" or legacy "+34612345678"); only Spain and
	 * Andorra have one
	 */
	prefixFlagUrl(phone: string | null | undefined): string | null {
		if (!phone) return null;
		const prefix = phone.includes('|') ? phone.split('|')[0] : phone;
		if (prefix.startsWith('+34')) return 'assets/layout/images/esp.png';
		if (prefix.startsWith('+376')) return 'assets/layout/images/and.png';
		return null;
	}

	/**
	 * Stored phone for display: "+34 612 345 678" (Spain/Andorra or the "+prefix|number" format);
	 * unknown formats are returned as they are, empty as "-"
	 */
	formatPrefixed(phone: string | null | undefined): string {
		if (!phone) return '-';

		let prefix: string;
		let number: string;
		if (phone.includes('|')) {
			[prefix, number] = phone.split('|');
		} else if (phone.startsWith('+34')) {
			prefix = '+34';
			number = phone.slice(3);
		} else if (phone.startsWith('+376')) {
			prefix = '+376';
			number = phone.slice(4);
		} else {
			return phone;
		}

		// Digits only, a space every 3
		const grouped = number.replace(/\D/g, '').replace(/(\d{3})(?=\d)/g, '$1 ');
		return `${prefix} ${grouped}`;
	}
}
